import { defineTemplate } from 'src/utils';
import { macroSelectaGlass1920x1920 } from './layouts/selecta-glass-1920x1920';
import { CATEGORY_OPTIONS } from '../_shared/data/category-options';
import { PAYMENT_METHOD_TEXT_OPTIONS_SELECTA } from '../_shared/data/payment-method-options';
import { LEGALES_OPTIONS } from '../_shared/data/legales-options';
import { MACRO_MEDIA_BASE } from '../_shared/data/media';
import { WALLETS_OPTIONS } from '../_shared/data/wallets-options';

const THUMB = `${MACRO_MEDIA_BASE}/templates/selecta-glass/thumbnails/selecta-glass.png`;

export const macroSelectaGlass = defineTemplate({
  mode: 'wysiwyg',
  id: 'macro-selecta-glass',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Selecta Glass',
  thumbnail: { url: THUMB, optimizedUrl: THUMB, aspectRatio: 'square' },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'category',
      label: 'Categoría',
      type: 'select',
      required: true,
      defaultValue: 'TRANSPORTE',
      placeholder: 'Selecciona una categoría',
      options: CATEGORY_OPTIONS
    },
    {
      key: 'valid-days',
      label: 'Días de validez',
      type: 'input',
      placeholder: 'Lunes a viernes',
      required: true,
      defaultValue: 'Todos los días'
    },
    {
      key: 'discount-value',
      label: 'Texto del descuento',
      type: 'number',
      placeholder: '30%',
      required: true,
      defaultValue: 30
    },
    {
      key: 'benefit-label',
      label: 'Beneficio',
      type: 'input',
      placeholder: 'de ahorro',
      required: true,
      defaultValue: 'de ahorro'
    },
    {
      key: 'payment-method-text',
      label: 'Mensaje principal',
      type: 'input',
      placeholder: 'Con Tarjetas de Crédito Macro Selecta',
      required: true,
      defaultValue: 'Con Tarjetas de Crédito Macro Selecta',
      options: PAYMENT_METHOD_TEXT_OPTIONS_SELECTA
    },
    {
      key: 'payment-method-highlight-text',
      label: 'Mensaje',
      type: 'input',
      placeholder: 'Pagando con tu celular sin contacto',
      required: true,
      defaultValue: 'Pagando con tu celular sin contacto'
    },
    {
      key: 'wallets-enabled',
      label: 'Billeteras digitales',
      type: 'image-multi-select',
      required: true,
      defaultValue: [],
      options: WALLETS_OPTIONS
    },
    {
      key: 'limit-text',
      label: 'Texto del tope',
      type: 'input',
      multiline: true,
      placeholder: 'Tope $100.000 por cuenta, por mes.',
      required: true,
      defaultValue: 'Tope $100.000 por cuenta, por mes.'
    },
    {
      key: 'legales',
      label: 'Legales',
      type: 'input',
      placeholder: 'CARTERA CONSUMO',
      required: false,
      options: LEGALES_OPTIONS,
      multiline: true
    },
    {
      key: 'background-image',
      label: 'Imagen de fondo',
      type: 'image',
      required: false
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1920x1920',
        label: '1920x1920',
        canvasWidth: 1920,
        canvasHeight: 1920,
        type: 'image',
        layout: macroSelectaGlass1920x1920
      }
    ],

    fieldBindings: [
      { kind: 'simple', fieldKey: 'category', pieceId: 'category', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'valid-days', pieceId: 'valid-days', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'discount-value', pieceId: 'discount-value', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'benefit-label', pieceId: 'benefit-label', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'limit-text', pieceId: 'limit-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-method-text', pieceId: 'payment-method-text', bindingType: 'text' },
      {
        kind: 'simple',
        fieldKey: 'payment-method-highlight-text',
        pieceId: 'payment-method-highlight-text',
        bindingType: 'text'
      },
      { kind: 'simple', fieldKey: 'wallets-enabled', pieceId: 'wallets', bindingType: 'group-collection' },
      { kind: 'simple', fieldKey: 'legales', pieceId: 'legales', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'background-image', pieceId: 'background-image', bindingType: 'image-replace' }
    ]
  }
});
